import React from 'react';

import { SimpleIcon, useSvgId } from './icon-utils';

export function ClipBoardIcon() {
  const clipPathId = useSvgId('clipboard-icon-clip');

  return (
    <SimpleIcon height={12} viewBoxDimensions="0 0 12 12" width={12}>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M7.5 3H1.5C1.05 3 0.75 3.3 0.75 3.75V11.25C0.75 11.7 1.05 12 1.5 12H7.5C7.95 12 8.25 11.7 8.25 11.25V3.75C8.25 3.3 7.95 3 7.5 3Z"
          fill="white"
        />
        <path d="M10.5 0H3V1.5H9.75V9.75H11.25V0.75C11.25 0.3 10.95 0 10.5 0Z" fill="white" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect fill="white" height="12" width="12" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}

export function WorkflowLaunchConfigBackground({ className }: { className: string }) {
  const backgroundGradientId = useSvgId('workflow-launch-background-gradient');
  const smallCircleGradientId = useSvgId('workflow-launch-small-circle-gradient');
  const largeCircleGradientId = useSvgId('workflow-launch-large-circle-gradient');
  const barGradientId = useSvgId('workflow-launch-bar-gradient');
  const clipPathId = useSvgId('workflow-launch-config-clip');
  const bottomSmallCircleGradientId = useSvgId('workflow-launch-bottom-small-circle-gradient');
  const bottomLargeCircleGradientId = useSvgId('workflow-launch-bottom-large-circle-gradient');

  return (
    <SimpleIcon className={className} height={816} viewBoxDimensions="0 0 1440 851" width={1440}>
      <ellipse cx="720" cy="-94.5" fill={`url(#${backgroundGradientId})`} rx="640" ry="395.5" />
      <circle
        cx="4.5"
        cy="4.5"
        fill={`url(#${smallCircleGradientId})`}
        r="4.5"
        transform="matrix(-1 0 0 1 1187 483)"
      />
      <circle
        cx="30.5"
        cy="30.5"
        fill={`url(#${largeCircleGradientId})`}
        r="30.5"
        transform="matrix(-1 0 0 1 1280 406)"
      />
      <rect
        fill={`url(#${barGradientId})`}
        height="521.519"
        rx="26.7424"
        transform="matrix(-0.906308 0.422618 0.422618 0.906308 1328.47 287)"
        width="53.4849"
      />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M1474.95 851H1352.05C1350.92 851 1350 850.176 1350 849.161C1350 848.146 1350.92 847.323 1352.05 847.323H1474.95C1476.08 847.323 1477 848.146 1477 849.161C1477 850.176 1476.08 851 1474.95 851Z"
          fill="#00866A"
        />
        <path
          d="M1384.06 813.069C1379.49 808.963 1373.51 806.735 1367.81 806.906C1362.31 813.869 1356.85 833.486 1356.2 835.854C1356.03 836.48 1356.24 837.138 1356.75 837.592C1357.13 837.94 1357.66 838.129 1358.19 838.129C1358.36 838.129 1358.52 838.112 1358.68 838.076C1361.31 837.497 1383.13 832.604 1390.91 827.669C1391.1 822.542 1388.63 817.166 1384.06 813.069Z"
          fill="#CB3E6D"
        />
        <path
          d="M1463.96 741.347C1460.84 738.545 1456.69 737 1452.27 737C1447.86 737 1443.71 738.545 1440.58 741.347L1371.48 803.379C1377.06 804.058 1382.59 806.542 1386.96 810.469C1391.33 814.391 1394.09 819.358 1394.84 824.385L1463.96 762.336C1467.09 759.531 1468.81 755.805 1468.81 751.84C1468.81 747.876 1467.09 744.151 1463.96 741.347Z"
          fill="#146EE8"
        />
      </g>
      <circle
        cx="6.5"
        cy="6.5"
        fill={`url(#${bottomSmallCircleGradientId})`}
        r="6.5"
        transform="matrix(-1 0 0 1 189 637)"
      />
      <circle
        cx="54.5"
        cy="54.5"
        fill={`url(#${bottomLargeCircleGradientId})`}
        r="54.5"
        transform="matrix(-1 0 0 1 189 516)"
      />
      <path
        d="M-69 564L-52.2691 538.335C-48.8361 533.069 -46.1851 527.333 -44.3991 521.305L-29.7648 471.918C-28.1785 466.564 -25.909 461.438 -23.0124 456.664L-11.529 437.74C-9.3283 434.114 -6.5551 430.867 -3.317 428.127L2.1966 423.46C5.7351 420.466 10.2208 418.822 14.8565 418.822C18.4016 418.822 21.8803 419.784 24.922 421.605L31.564 425.581C38.873 429.956 44.875 436.214 48.941 443.699L53.683 452.428C62.485 469.509 87.493 467.61 93.616 449.397L95.308 444.363L107.69 415.141C108.913 412.255 110.764 409.676 113.107 407.594L113.599 407.157C120.553 400.977 130.82 400.322 138.504 405.567C145.81 410.556 155.508 410.232 162.465 404.767L167.015 401.193C174.495 395.316 184.965 395.11 192.671 400.688C200.791 406.565 211.909 405.988 219.377 399.302L232 388"
        fill="none"
        stroke="#146EE8"
        strokeWidth="5"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={backgroundGradientId}
          x1="799"
          x2="365.543"
          y1="-366"
          y2="475.404"
        >
          <stop stopColor="#CB3E6D" />
          <stop offset="1" stopColor="#146EE8" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={smallCircleGradientId}
          x1="1.85098"
          x2="-2.69169"
          y1="-2.27134"
          y2="6.72866"
        >
          <stop stopColor="#CB3E6D" />
          <stop offset="1" stopColor="#146EE8" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={largeCircleGradientId}
          x1="12.5456"
          x2="-18.2437"
          y1="-15.3946"
          y2="45.6054"
        >
          <stop stopColor="#CB3E6D" />
          <stop offset="1" stopColor="#146EE8" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={barGradientId}
          x1="2.72697"
          x2="22.8737"
          y1="95.8256"
          y2="1020.44"
        >
          <stop stopColor="#CB3E6D" />
          <stop offset="1" stopColor="#146EE8" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={bottomSmallCircleGradientId}
          x1="2.67364"
          x2="-3.888"
          y1="-3.28082"
          y2="9.71918"
        >
          <stop stopColor="#CB3E6D" />
          <stop offset="1" stopColor="#146EE8" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={bottomLargeCircleGradientId}
          x1="22.4175"
          x2="-32.5993"
          y1="-27.5084"
          y2="81.4916"
        >
          <stop stopColor="#CB3E6D" />
          <stop offset="1" stopColor="#146EE8" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect fill="white" height="114" transform="translate(1350 737)" width="127" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}
